// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetActivityResponse

export type WidgetActivityApiResponse = {
	id: string;
	name: string;
	from: string | null;
	to: string | null;
	minPax: number;
	maxPax: number;
	image: string | null;
};

export type WidgetActivity = {
	id: string;
	name: string;
	from: string | null;
	to: string | null;
	minPax: number;
	maxPax: number;
	image: string | null;
};

export function hydrateWidgetActivity(data: WidgetActivityApiResponse): WidgetActivity {
	return { ...data };
}